var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-content-between p-3 p-md-4" },
    [
      _c("div", [
        _c("i", { staticClass: "fad fa-envelope-open" }),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "pl-1",
            staticStyle: { color: "#444", "background-color": "#fff" },
            attrs: {
              href: "mailto:" + _vm.email,
              "data-gtm-name":
                _vm.utmCampaign === "login"
                  ? "login_yektanet_email"
                  : "logout_yektanet_email"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.email) + "\n    ")]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("i", { staticClass: "fad fa-phone" }),
        _vm._v(" "),
        _c(
          "a",
          {
            class: ["pl-1", { fanum: _vm.$i18n.locale === "fa" }],
            staticStyle: { color: "#444", "background-color": "#fff" },
            attrs: {
              href: "tel:02145195000",
              "data-gtm-name":
                _vm.utmCampaign === "login"
                  ? "login_yektanet_phone"
                  : "logout_yektanet_phone"
            }
          },
          [_vm._v("\n      021-45195000\n    ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }